import { LegalLayout } from "@/components/site/LegalLayout";
import { legal } from "@/config/content";

export default function Datenschutz() {
  return (
    <LegalLayout title="Datenschutzerklärung">
      <p className="text-sm bg-white border border-border rounded-lg p-4">
        Diese Datenschutzerklärung beschreibt die tatsächlichen Datenverarbeitungen dieser Website.
        Bitte lassen Sie den Inhalt vor der endgültigen Veröffentlichung rechtlich prüfen und die
        Auftragsverarbeitungsverträge (AVV) mit den eingesetzten Dienstleistern bestätigen.
      </p>

      <h2>1. Verantwortlicher</h2>
      <p>
        {legal.brandLine}<br />
        {legal.companyName}<br />
        {legal.street}, {legal.postalCity}, {legal.country}<br />
        Geschäftsführer: {legal.managingDirector}<br />
        E-Mail: {legal.email} · Telefon: {legal.phone}
      </p>

      <h2>2. Hosting und Server-Logfiles</h2>
      <p>
        Diese Website wird bei einem Hosting-Dienstleister betrieben. Beim Aufruf der Seite werden
        technisch notwendige Zugriffsdaten verarbeitet (u. a. IP-Adresse, Datum und Uhrzeit des
        Zugriffs, aufgerufene Seite, übertragene Datenmenge, Browsertyp). Diese Verarbeitung dient
        der sicheren und stabilen Bereitstellung der Website. Rechtsgrundlage ist Art. 6 Abs. 1
        lit. f DSGVO (berechtigtes Interesse an einem sicheren Betrieb).
      </p>

      <h2>3. Anfrage- und Kontaktformular</h2>
      <p>
        Wenn Sie uns über das Anfrageformular kontaktieren, verarbeiten wir die von Ihnen
        angegebenen Daten: Vor- und Nachname, ggf. Unternehmen, Telefonnummer, E-Mail-Adresse,
        Postleitzahl, Ort, Kundentyp, gewünschte Leistung, Angaben zu Objekt/Projekt, Fläche/Größe,
        gewünschter Beginn, Ihre Nachricht sowie optional von Ihnen hochgeladene Dateien. Zusätzlich
        wird zur Missbrauchs- und Spam-Abwehr technisch Ihre IP-Adresse verarbeitet. Die
        Verarbeitung erfolgt zur Bearbeitung Ihrer Anfrage und zur Kontaktaufnahme. Rechtsgrundlage
        ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen) sowie Art. 6 Abs. 1 lit. f DSGVO.
      </p>

      <h2>4. Datei-Uploads und Speicherung</h2>
      <p>
        Optional hochgeladene Dateien (z. B. Bilder oder Dokumente) werden bei einem
        Speicher-Dienstleister (Object Storage) abgelegt, den wir als Auftragsverarbeiter im Rahmen
        unserer technischen Infrastruktur einsetzen. Die zugehörigen Anfragedaten werden in einer
        Datenbank (MongoDB) auf unserer Serverinfrastruktur gespeichert. Der Zugriff auf hochgeladene
        Dateien und Anfragedaten ist ausschließlich über einen passwortgeschützten, intern genutzten
        Administrationsbereich möglich.
      </p>

      <h2>5. E-Mail-Verarbeitung und automatische Eingangsbestätigung</h2>
      <p>
        Zur Zustellung der Anfrage an uns sowie zur automatischen Eingangsbestätigung an Sie setzen
        wir den E-Mail-Versanddienst „Resend“ (Resend, Inc.) ein, der über unseren
        Integrations-Dienstleister angebunden ist. Dabei werden die für den Versand erforderlichen
        Daten (insbesondere Ihre E-Mail-Adresse und der Nachrichteninhalt) verarbeitet. Die
        automatische Bestätigung informiert Sie lediglich über den Eingang Ihrer Anfrage; eine
        bestimmte Reaktionszeit ist damit nicht verbunden. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b
        und lit. f DSGVO.
      </p>

      <h2>6. Schriftarten</h2>
      <p>
        Die auf dieser Website verwendeten Schriftarten werden lokal von unserem Server
        ausgeliefert (Self-Hosting). Es werden keine Schriftarten von externen Anbietern wie Google
        Fonts geladen; eine Übertragung Ihrer IP-Adresse an Google oder andere Dritte zum Zweck der
        Schriftdarstellung findet somit nicht statt.
      </p>

      <h2>7. Cookies und lokale Speicherung</h2>
      <p>
        Für Besucherinnen und Besucher der Website werden keine nicht notwendigen Cookies gesetzt
        und keine Analyse- oder Marketing-Dienste eingesetzt. Lediglich im internen
        Administrationsbereich wird nach der Anmeldung ein technisch notwendiges Sitzungs-Cookie
        gesetzt (HttpOnly, Secure, SameSite), das ausschließlich der sicheren Authentifizierung
        dient. Da ausschließlich technisch notwendige Speicherung erfolgt, ist kein
        Einwilligungsbanner erforderlich.
      </p>

      <h2>8. Empfänger / Auftragsverarbeiter</h2>
      <p>
        Zur Bereitstellung der Website und Bearbeitung von Anfragen setzen wir Dienstleister ein
        (Hosting/Infrastruktur, Object Storage, Datenbank sowie den E-Mail-Dienst Resend). Mit diesen
        Dienstleistern bestehen bzw. werden – soweit erforderlich – Verträge zur Auftragsverarbeitung
        gemäß Art. 28 DSGVO geschlossen.
      </p>

      <h2>9. Speicherdauer</h2>
      <p>
        Wir speichern Ihre Daten nur so lange, wie es für die Bearbeitung Ihrer Anfrage und die
        Erfüllung gesetzlicher Aufbewahrungspflichten erforderlich ist. Anschließend werden die
        Daten gelöscht.
      </p>

      <h2>10. Ihre Rechte</h2>
      <p>
        Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung,
        Datenübertragbarkeit sowie Widerspruch. Zudem steht Ihnen ein Beschwerderecht bei einer
        Datenschutz-Aufsichtsbehörde zu. Bei Fragen zum Datenschutz erreichen Sie uns unter{" "}
        {legal.email}.
      </p>
    </LegalLayout>
  );
}
